import { render } from "./ThirdParty.vue?vue&type=template&id=5efd859c"
import script from "./ThirdParty.vue?vue&type=script&lang=js"
export * from "./ThirdParty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__